import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { UserProgramContext } from "@Providers/ProgramProvider"
import { userAtom } from "@Recoil/Atom/userAtom"
import ProgramService from "@Services/Program.Service"
import { UserService } from "@Services/User.service"
import { useContext } from "react"
import { useRecoilValue } from "recoil"

export const useUserPrograms = () => {
    const user = useRecoilValue(userAtom)

    const {
        userPrograms,
        setUserPrograms,
        fetchingUserPrograms,
        setFetchingUserPrograms,

        preselectedPatientProgram,
        setPreselectedPatientProgram,
        fetchingPreselectedPatientProgram,
        setFetchingPreselectedPatientProgram
    } = useContext(UserProgramContext)

    const { fetchingDiagEduc, hasEducationalDiagnosis } = useContext(DiagnosticEducatifContext)

    const fetchUserPrograms = () => {
        setFetchingUserPrograms(true)
        UserService.getUserPrograms(user?.id ?? 0)
            .then((res) => {
                const data = res?.data?.data
                setUserPrograms(data)
                setFetchingUserPrograms(false)
            })
            .catch((err) => {
                setFetchingUserPrograms(false)
            })
    }

    const fetchPreselctedPatientProgram = () => {
        setFetchingPreselectedPatientProgram(true)
        ProgramService.GetPreselctedPatientProgram({ patientId: user?.id })
            .then((res) => {
                const data = res?.data?.data
                setPreselectedPatientProgram(data)
                setFetchingPreselectedPatientProgram(false)
            })
            .catch((err) => {
                setFetchingPreselectedPatientProgram(false)
            })
    }

    const disableMenu =
        (!hasEducationalDiagnosis &&
            (userPrograms?.length === 0 ||
                (userPrograms?.length === 1 && userPrograms?.[0]?.stateProgramUserTemp !== "TERMINE"))) ||
        fetchingUserPrograms ||
        fetchingDiagEduc

    const hasProgramInProgress = preselectedPatientProgram?.some((program) => program?.preselected === 1)

    const currentUserProgram = userPrograms?.length > 0 ? userPrograms?.[userPrograms?.length - 1] : null

    return {
        fetchPreselctedPatientProgram,
        fetchUserPrograms,
        disableMenu,
        fetchingUserPrograms,
        userPrograms,
        currentUserProgram,

        hasProgramInProgress,
        fetchingPreselectedPatientProgram
    }
}
